export const sales = state => state.sales

export const pagination = state => state.pagination
